/**
 * Apre una nuova finestra/tab con il contenuto HTML fornito, evitando `document.write()`
 * (deprecato e flaggato come XSS-prone dai linter di sicurezza).
 *
 * Usa una Blob URL: il browser tratta la pagina come un normale documento HTML,
 * `window.print()` funziona nativamente, niente race condition con DOMContentLoaded.
 *
 * @param {string} html - Documento HTML completo (incluso <!DOCTYPE html>...</html>).
 * @param {object} [opts]
 * @param {boolean} [opts.autoPrint=false] - Se true, invoca window.print() dopo il load.
 * @param {string} [opts.title] - Se passato, sostituisce <title> nel documento.
 * @returns {Window | null} Riferimento alla nuova finestra (o null se popup bloccato).
 */
export function openPrintWindow(html, opts = {}) {
  const { autoPrint = false } = opts;
  const blob = new Blob([html], { type: "text/html;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const w = window.open(url, "_blank");
  if (!w) {
    URL.revokeObjectURL(url);
    return null;
  }
  if (autoPrint) {
    // Aspetta che la finestra carichi prima di stampare
    const tryPrint = () => {
      try {
        w.focus();
        w.print();
      } catch {
        // Popup blocker o cross-origin: lasciamo perdere
      }
    };
    // onload sulla nuova finestra (può non scattare se già caricata)
    try {
      w.addEventListener("load", tryPrint, { once: true });
    } catch {
      setTimeout(tryPrint, 500);
    }
  }
  // Pulizia memory: revoca dopo 60s, abbondante per caricamento + stampa
  setTimeout(() => {
    try { URL.revokeObjectURL(url); } catch { /* ignore */ }
  }, 60000);
  return w;
}
